<template>
  <div>
    <iframe :src="srcs" class="iframe" ref="iframes"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      srcs: "",
      // codeList: [
      //   "userCode",
      //   "orgCode",
      //   "deptCode",
      //   "defaultRoleId",
      //   "defaultDeptId",
      // ],
    };
  },
  created() {
    this.srcs = `https://www.taclmy.com:10081/ureport/designer`;
  },
  watch: {
    // 监听路由变化，当路由发生变化的时候，重新加载子组件，通过v-if来判断，记得加key值，这样vue就会重新渲染页面
    $route() {
      this.srcs = `https://www.taclmy.com:10081/ureport/designer`;
    },
  },
  methods: {
    // setUrl() {
    //   let obj = JSON.parse(localStorage.getItem("saber-userInfo")).content;
    //   let str = "";
    //   for (let key in obj) {
    //     this.codeList.map(it=>{
    //         if (it.indexOf(key) != -1) {
    //             str+=`&${key}=${obj[key]}`
    //         }
    //     })
    //
    //   }
    //   return str;
    // },
  },
};
</script>
<style scoped>
.avue-view {
  height: 100% !important;
}
.iframe{
  width: 100%;
  height: calc(100vh - 124px);
}
/* 设置滚动条的样式 */
.iframe::-webkit-scrollbar {
  width: 3px;
}
/*滚动槽*/
.iframe::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
/* 滚动条滑块 */
.iframe::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/views/report/reportDesigner.vue